import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import {
  UniCardModule,
  UniHeadingModule,
  UniIconsModule,
  UniLinkModule,
  UniListModule,
  UniFormFieldModule,
  UniInputModule,
} from "@universal-ui";
import { AngularSvgIconModule } from "angular-svg-icon";
import { NgxMasonryModule } from "ngx-masonry";
import { UniButtonsModule } from "src/ui/components/buttons/buttons.module";

import { SharedModule } from "@shared/Modules/shared.module";

import { MobileMenuComponent } from "../MobileMenu/mobile-menu.component";

import { DesktopMenuAllOptionsComponent } from "./desktop-menu-all-options/desktop-menu-all-options.component";
import { DesktopMenuSectionComponent } from "./desktop-menu-section/desktop-menu-section.component";
import { DesktopMenuComponent } from "./desktop-menu.component";

@NgModule({
  declarations: [DesktopMenuComponent, DesktopMenuSectionComponent, DesktopMenuAllOptionsComponent, MobileMenuComponent],
  imports: [
    CommonModule,
    UniListModule,
    UniLinkModule,
    RouterModule,
    UniHeadingModule,
    UniIconsModule,
    UniInputModule,
    UniButtonsModule,
    UniFormFieldModule,
    UniCardModule,
    ReactiveFormsModule,
    NgxMasonryModule,
    SharedModule,
    AngularSvgIconModule,
  ],
  exports: [DesktopMenuComponent, MobileMenuComponent],
})
export class DesktopMenuModule {}
